module.exports = __webpack_public_path__ + "img/20.07f6ff3b.jpg";